module.exports = {
  ...require('./eilistraee'),
  ...require('./eldath'),
  ...require('./erevan_ilesere'),
}
